var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "500px" },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        { staticClass: "pb-3" },
        [
          _c("v-card-title", [
            _c("span", { staticClass: "headline" }, [_vm._v("Edit Day")]),
          ]),
          _c(
            "v-card-text",
            [
              _c("span", [_vm._v("UID: " + _vm._s(_vm.model.uid))]),
              _c("v-text-field", {
                staticClass: "mt-3",
                attrs: { label: "Name:", "hide-details": "" },
                model: {
                  value: _vm.model.name,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.model,
                      "name",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "model.name",
                },
              }),
              _c("v-text-field", {
                staticClass: "mt-3",
                attrs: { label: "Key:", "hide-details": "" },
                model: {
                  value: _vm.model.key,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.model,
                      "key",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "model.key",
                },
              }),
              _c("v-text-field", {
                staticClass: "mt-3",
                attrs: { label: "Delay to start:", "hide-details": "" },
                on: {
                  input: (val) => (_vm.model.latency = parseInt(val) || 0),
                },
                model: {
                  value: _vm.model.latency,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.model,
                      "latency",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "model.latency",
                },
              }),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "red ", text: "" },
                  on: { click: _vm.cancel },
                },
                [_vm._v(" Cancel ")]
              ),
              _c(
                "v-btn",
                {
                  staticClass: "white--text",
                  attrs: { color: "green" },
                  on: { click: _vm.save },
                },
                [_vm._v(" Save ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }